/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import dayjs from "dayjs";

declare global {
  /* eslint-disable-next-line @typescript-eslint/consistent-type-definitions */
  interface Window {
    mca?: {
      period?: string;
    };
  }
}

export enum BILLING_PERIOD {
  current = "current",
  previous = "previous",
}

export const restatePeriod = () => {
  const billingPeriod =
    localStorage.getItem("billingPeriod") || BILLING_PERIOD.current;

  if (billingPeriod) {
    setPeriod(billingPeriod);
    return billingPeriod;
  }

  return null;
};

export const getPeriod = () => {
  if (window.mca?.period) {
    return {
      period: window.mca?.period,
    };
  }

  const billingPeriod =
    localStorage.getItem("billingPeriod") || BILLING_PERIOD.current;

  return { period: billingPeriod };
};

const isCurrentPeriod = () => {
  const { period = BILLING_PERIOD.current } = getPeriod() || {};

  return period === BILLING_PERIOD.current;
};

export const periodDayJs = () => {
  if (isCurrentPeriod()) {
    return dayjs();
  }

  return dayjs().subtract(1, "month");
};

export const setPeriod = (billingPeriod: string) => {
  if (window.mca) {
    window.mca.period = billingPeriod;
  } else {
    window.mca = { period: billingPeriod };
  }

  localStorage.setItem("billingPeriod", billingPeriod);
};
